<template>
<div>
	<h2>Please wait... Redirecting to our help center. </h2>
</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'userZendesk',
  props: [],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
    this.loadUserZendesk()
  },

  methods: {
    ...mapActions([
      'loadZendeskJWT'
    ]),

    loadUserZendesk () {
      let redirect = this.$route.query.return_to
      console.log('redirect:', redirect)
      this.loadZendeskJWT(redirect).then(res => {
        console.log('res:', res)
        window.location.href = res
      })
    }
  },

  computed: {
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/user/components/UserZendesk.vue